import React, {useEffect, useState} from 'react';
import {File, X} from "react-feather";
import {formatBytes} from "../../services/helpers";

const FileList = ({onRemoveFile, fileList}) => {
    const [itemFiles, setItemFiles] = useState(fileList);
    const handleRemoveFile = (file) => {
        onRemoveFile(file);
    };
    useEffect(() => {
        setItemFiles(fileList);
    }, [fileList]);
    return (
        <div className="sl-w-full sl-flex sl-flex-col sl-gap-2 sl-align-center sl-justify-center">
            {itemFiles.map((file, index) => (
                <div
                    key={index}
                    rel={file.location}
                    className='sl-flex sl-border-bottom-not-last sl-pb-2-last-0 sl-rounded-lg sl-w-fill-available sl-justify-space-between sl-align-center'>
                    <div className="sl-flex sl-w-full sl-justify-start sl-align-center sl-gap-3 sl-mb-2">

                        <div>
                            <div
                                className="sl-p-2 sl-m-auto sl-w-8 sl-h-8 sl-rounded-full sl-bg-primary-50 sl-text-primary-600">
                                <File size={16} className="sl-text-primary-600"/>
                            </div>
                        </div>

                        <div
                            className="sl-grow-1 sl-w-full sl-flex sl-flex-col sl-justify-items-start sl-align-flex-start">
                            <div className="sl-font sl-text-sm sl-font-medium sl-text-gray-900 sl-mr-1">
                                {file.name}
                            </div>
                            {file.error ?
                                <div className="sl-font-medium sl-text-xs sl-text-error-600">{file.error}</div>
                                : !file.size ?
                                    <div className="sl-font-normal sl-text-xs sl-text-primary-base">Uploading...</div>
                                    :
                                    <div className="sl-font-normal sl-text-xs sl-text-gray-base">
                                        Attached · {formatBytes(file.size)}
                                    </div>}
                        </div>

                        {(file.location || file.error) && <div className="sl-self-end" onClick={() => handleRemoveFile(file)}>
                            <X size={20} className="sl-cursor-pointer sl-text-gray-base"/>
                        </div>}
                    </div>
                </div>))}
        </div>
    );
};

export default FileList;
